export const AdSlotLabelHeight = 30;
